@import (reference) '../../../constants/spacing.module.less';

.pageContainer {
  padding: @space-32;
  background: var(--grey-100);
  min-height: 100%;
  height: 100%;
  overflow-y: auto;
}

.contentContainer {
  max-width: 800px;
  margin: @space-40 auto;
}

.appGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: @space-16;
}

.appCard {
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  padding: @space-16;
  background: var(--white);
  cursor: pointer;
  transition: border-color 0.2s;
  text-align: center;
  text-decoration: none;
  color: inherit;
}

.appCard:hover {
  border-color: var(--blue-500);
}

.appCardDisabled {
  cursor: default;
}

.appCardDisabled:hover {
  border-color: var(--grey-300);
}

.appIcon {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
}

.appIconPlaceholder {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background: var(--grey-200);
  display: grid;
  place-items: center;
  font-size: 24px;
  font-weight: 600;
  color: var(--grey-500);
}

.centerItems {
  align-items: center;
}

.dimText {
  color: var(--grey-500);
}

.errorText {
  color: var(--red-500);
}
